let baseUrl = "";
let CommercialUrl = "";
let sdkappid = "";
let SECRETKEY = "";

if (process.env.NODE_ENV == "development") {
    baseUrl = "https://ly.wf12123.com/api";
    sdkappid = 1600117629;
    SECRETKEY = "6c09276932d44c943ac53551329cc00ca5a873aa90edc50fadc88b34f42a8329";
} else if (process.env.NODE_ENV == "testing") {
    baseUrl = "https://ly.wf12123.com/api";
    sdkappid = 1600117629;
    SECRETKEY = "6c09276932d44c943ac53551329cc00ca5a873aa90edc50fadc88b34f42a8329";
} else if (process.env.NODE_ENV == "production") {
    baseUrl = "https://ly.wf12123.com/api";
    sdkappid = 1600117629;
    SECRETKEY = "6c09276932d44c943ac53551329cc00ca5a873aa90edc50fadc88b34f42a8329";
}

let configuration = {
    projectName: "交通违法远程辅助处理系统",
    miniName: "交通违法远程辅助处理系统",
    loginLogo: "/static/images/commons/logo_base.png",
    menuLogo: "/static/images/commons/logo_base.png",
    cityData: "",
    carRegion: "豫",
}

let ProductKey = "DLS2eyJoYW5kc2hha2VDb2RlIjoiMTAxODM2MjM5LTEwMTgzNjI0NyIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21sdHMuZHluYW1zb2Z0LmNvbS8iLCJvcmdhbml6YXRpb25JRCI6IjEwMTgzNjIzOSIsInN0YW5kYnlTZXJ2ZXJVUkwiOiJodHRwczovL3NsdHMuZHluYW1zb2Z0LmNvbS8iLCJjaGVja0NvZGUiOjE4NzkyODY2NH0=";
const pages_version = "V3.3.0";
const roomType = "lywf_"; //正式
/* 注解：
    单独音视频配置，不需要roomType，需要把代码中的roomType去掉（views/weifa/video.vue 和 views/weifa/videoEasy.vue）；
    公共音视频配置，需要roomType，需要把代码中的roomType加上（views/weifa/video.vue 和 views/weifa/videoEasy.vue）；
*/


export default {
    baseUrl,
    CommercialUrl,
    sdkappid,
    SECRETKEY,
    configuration,
    ProductKey,
    pages_version,
    roomType,
}



// WEBPACK FOOTER //
// ./src/common/env.js